module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.19.2@axios/index.js
// module id = 121
// module chunks = 39